import React from 'react';
import Slider from 'react-slick';

const banners = [
    '/images/testimonial/img01.jpeg',
    '/images/testimonial/img02.jpeg',
    '/images/testimonial/img03.jpeg',
];

export default function BannerCarousel() {
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        arrows: false,
        adaptiveHeight: true,
    };

    return (
        <div style={{ width: '100%' }}>
            <Slider {...settings}>
                {banners.map((src, index) => (
                    <div key={index} style={{ width: '100%' }}>
                        <img
                            src={src}
                            alt={`Banner ${index + 1}`}
                            style={{ width: '100%', height: 'auto', display: 'block' }}
                        />
                    </div>
                ))}
            </Slider>
        </div>
    );
}
